import { InjectionToken } from '@angular/core';

export interface HybridConfig {
    initialIframeSourceUrl: string;
}

export const HYBRID_CONFIG = new InjectionToken<HybridConfig>('__HYBRID_CONFIG__');
